<div>Logging out, please wait...</div>
